import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions as modalActions } from '@saucelabs/sl-container-modal';
import { withRouter } from 'react-router-dom';

import CreditRefreshModal from '../components/CreditRefreshModal';
import { CREDIT_REFRESH_MODAL_KEY } from '../../constants';

const CreditRefreshModalContainer = ({ credits, showModal, hideModal, userId, isFreemium }) => {
  // Only add this modal if the user is freemium type
  if (!isFreemium) return null;
  return (
    <CreditRefreshModal
      credits={credits}
      hideModal={hideModal}
      showModal={showModal}
      userId={userId}
    />
  );
};

CreditRefreshModalContainer.propTypes = {
  credits: PropTypes.shape({
    available_credits: PropTypes.arrayOf(
      PropTypes.shape({
        credits: PropTypes.number.isRequired,
        expiration_time: PropTypes.string.isRequired,
        grant_time: PropTypes.string.isRequired,
        source: PropTypes.string.isRequired,
      }),
    ),
  }),
  hideModal: PropTypes.func,
  isFreemium: PropTypes.bool,
  showModal: PropTypes.func,
  userId: PropTypes.string,
};

CreditRefreshModalContainer.defaultProps = {
  credits: null,
  hideModal: null,
  isFreemium: false,
  showModal: null,
  userId: null,
};

const mapStateToProps = (state) => ({
  credits: state.usage?.credits,
  userId: state.user?.get('user_id'),
  isFreemium: state.user?.get('user_type') === 'freemium',
});

const mapDispatchToProps = {
  showModal: () => modalActions.showModal(CREDIT_REFRESH_MODAL_KEY),
  hideModal: () => modalActions.hideModal(),
};

export default
withRouter(connect(mapStateToProps, mapDispatchToProps)(CreditRefreshModalContainer));

export {
  CreditRefreshModalContainer,
  mapStateToProps,
};
